import segmentPlugin from '@analytics/segment';
import { getSegmentWriteKey } from '@hopin-team/config-hopin-constants';
import {
  createClientConsentCallback,
  initAnalytics,
} from '@hopin-team/provider-analytics';

const plugins = [
  segmentPlugin({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore exists in lib
    enabled: false,
    writeKey: getSegmentWriteKey(),
  }),
];

export const clientCallback = createClientConsentCallback({
  MARKETING: ['segment'],
  ANALYTICS: ['segment'],
  analytics: ['segment'],
});

export const analyticsClient = initAnalytics({ plugins });
